import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import { ConfigProvider, theme } from "antd";
import queryString from "query-string";

const params = queryString.parse(window.location.search);
let themes = params["theme"]; // light or dark


ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider
      theme={themes === "dark" ? { algorithm: theme.darkAlgorithm } : {}}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
